import { URL_FLIGHTS } from "@/constants/EngineConstants";

export const replaceBookingUrl = (url: string): string => {
  return url.replace(
    'costamar.com.pe/vuelos',
    URL_FLIGHTS
  );
};
